type Props = {
  collapsed?: boolean;
};

export default function EmployeeTrackingIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.25 20.6949H15.75M12 8.69495C12 10.3518 10.6569 11.6949 9 11.6949C7.34315 11.6949 6 10.3518 6 8.69495C6 7.03809 7.34315 5.69495 9 5.69495C10.6569 5.69495 12 7.03809 12 8.69495ZM16.5 8.69495C16.5 15.4449 9 20.6949 9 20.6949C9 20.6949 1.5 15.4449 1.5 8.69495C1.5 6.70582 2.29018 4.79817 3.6967 3.39165C5.10322 1.98512 7.01088 1.19495 9 1.19495C10.9891 1.19495 12.8968 1.98512 14.3033 3.39165C15.7098 4.79817 16.5 6.70582 16.5 8.69495Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
